export function initAccordion() {
  document.querySelectorAll('.accordion-item .accordion-content').forEach(content => {
    const item = content.closest('.accordion-item');
    const isHidden = content.classList.contains('hidden');

    if (!isHidden) {
      item.classList.add('accordion-open');
      content.classList.remove('hidden');
      content.classList.add('open');
      const icon = item.querySelector('.fa-chevron-down');
      if (icon) icon.classList.add('rotate-180');
    }
  });

  document.addEventListener('click', e => {
    const trigger = e.target.closest('.accordion-trigger');
    if (!trigger) return;

    const item = trigger.closest('.accordion-item');
    if (!item) return;

    const content = item.querySelector('.accordion-content');
    const icon = trigger.querySelector('.fa-chevron-down');
    const isOpen = item.classList.contains('accordion-open');

    if (isOpen) {
      closeItem(item, content, icon);
    } else {
      openItem(item, content, icon);
    }
  });
}

function openItem(item, content, icon) {
  item.classList.add('accordion-open');
  if (content) {
    content.classList.remove('hidden');
    content.classList.add('open');
  }
  if (icon) icon.classList.add('rotate-180');
}

function closeItem(item, content, icon) {
  item.classList.remove('accordion-open');
  if (content) {
    content.classList.remove('open');
    content.classList.add('hidden');
  }
  if (icon) icon.classList.remove('rotate-180');
}
